var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"site_button",staticClass:"site_button",class:[_vm.theme, _vm.type, (_vm.is_hovered ? 'is_hovered' : null)],attrs:{"type":"submit"},on:{"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[_c('span',{staticClass:"hover_arrow"},[_vm._v("→")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.button_label ? _vm.button_label : _vm.parsedLink.title)}}),_vm._v(" "),_c('span',{staticClass:"arrow"},[_vm._v("→")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/SubmitButton.vue